import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectDocumentType = ({
  selectedDocumentType,
  onChange,
  disabled,
  placeholder = 'documentTypePlaceholder',
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [documentTypes, setDocumentTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectDocumentType = (item) => {
    const documentType = item ? documentTypes.find((dt) => dt.value === item.value) : null;
    onChange(documentType);
  };

  const getDocumentTypes = useCallback(async (search) => {
    setLoading(true);
    try {
      const params = { search, isServiceCreation: true };
      const { documentTypes: documentTypesList } = await InteroperableDataService.getDocumentTypes(params);
      setDocumentTypes(documentTypesList);
    } catch (error) {
      setDocumentTypes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getOptionData = useCallback((documentType) => {
    return {
      value: documentType.value,
      label: documentType.description,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t(placeholder)}
      isLoading={loading}
      onChange={selectDocumentType}
      options={documentTypes}
      value={selectedDocumentType}
      onSearch={getDocumentTypes}
      getOptionData={getOptionData}
      disabled={disabled}
    />
  );
};

SelectDocumentType.propTypes = {
  selectedDocumentType: PropTypes.shape({
    value: PropTypes.string,
    description: PropTypes.string,
  }),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};
